import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {RecoverPasswordForm} from '../recover-password-form';
import {Alert} from '../../../utils/alert';
import {ValidatorUtils} from '../../../utils/validator-utils';
import {UserService} from '../../../services/security/user.service';
import {PasswordService} from '../../../services/security/password.service';
import {TranslateService} from '@ngx-translate/core';
import {PasswordSecurity} from '../../../model/security/password-security';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  @Output() cancel = new EventEmitter<void>();
  @Output() changed = new EventEmitter<void>();

  recoverPasswordForm = RecoverPasswordForm.getForm();
  readonly RecoverPasswordForm = RecoverPasswordForm;

  displayErrorDynamic = false;
  loading = false;
  passwordSecurity: PasswordSecurity | undefined;
  alert: Alert | undefined;

  constructor(
    private userService: UserService,
    public passwordService: PasswordService,
    public translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.recoverPasswordForm = RecoverPasswordForm.getForm(this.passwordSecurity);
  }

  getUsername(): string | null {
    return localStorage.getItem('username');
  }

  changePassword() {
    this.displayErrorDynamic = true;
    const password = RecoverPasswordForm.getValue(this.recoverPasswordForm);

    // @ts-ignore
    if (this.passwordService.checkPasswords(this.passwordSecurity, password.newPassword, password.confirmPassword)) {
      if (this.recoverPasswordForm.valid) {
        this.loading = true;
        // @ts-ignore
        this.userService.recoverPassword(localStorage.getItem('username'), localStorage.getItem('password'), password.newPassword)
          .subscribe(
            apiValidation => {
              if (apiValidation.success) {
                localStorage.removeItem('username');
                localStorage.removeItem('password');
                this.changed.emit();
              }
              this.loading = false;
            },
            err => {
              console.error('Can\'t change password', err);
              this.loading = false;
            }
          );
      } else {
        this.alert = ValidatorUtils.getFormError(this.recoverPasswordForm, RecoverPasswordForm.FIELDS.NEW_PASSWORD)
          .getAlert(Alert.Status.ERROR, this.translateService);
      }
    } else {
      // @ts-ignore
      const reason = this.passwordService.getFailureReason(this.passwordSecurity, password.newPassword, password.confirmPassword);
      this.alert = new Alert(Alert.Status.ERROR, '', reason || {key: 'error.message.not_valid_data', params: {}});
    }
  }

  getError(): string | undefined {
    let error: string | undefined;

    if (this.displayErrorDynamic && this.recoverPasswordForm.invalid && (this.recoverPasswordForm.dirty || this.recoverPasswordForm.touched)) {
      error = ValidatorUtils.getFormError(this.recoverPasswordForm, RecoverPasswordForm.FIELDS.NEW_PASSWORD).getI18n(this.translateService);
    }
    if (error) {
      this.alert = undefined;
    }
    if (!error && this.alert) {
      error = this.translateService.instant(this.alert.detail.key, this.alert.detail.params);
    }
    return error;
  }
}
